import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { ThemeProvider } from '@/contexts/ThemeContext'
import { TeamsProvider } from '@/contexts/TeamsContext'
import App from './App.tsx'
import './styles/globals.css'

const isOutlookAddinRoute = window.location.pathname.startsWith('/addin/outlook')

// MSAL configuration
const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_AAD_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AAD_TENANT_ID || ''}`,
    redirectUri: window.location.origin + '/auth/callback',
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: isOutlookAddinRoute ? 'localStorage' : 'sessionStorage',
    storeAuthStateInCookie: false,
  },
}

// Create MSAL instance
const msalInstance = new PublicClientApplication(msalConfig)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <BrowserRouter 
        future={{ 
          v7_startTransition: true,
          v7_relativeSplatPath: true 
        }}
      >
        <TeamsProvider>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </TeamsProvider>
      </BrowserRouter>
    </MsalProvider>
  </React.StrictMode>,
)
